<template>
  <v-container>
    <Navigation />
    <v-col
      cols="12"
      sm="12"
      xs="4"
      class="ml-2"
      :class="{ 'col-md-12': isChrome, 'col-md-10': isFirefox }"
    >
      <div class="container mx-5">
        <TableWithSearch
          :items="getAttributes"
          :headers="allHeaders"
          :title="title"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
        />
      </div>

      <v-dialog v-model="showAdd" max-width="490px" persistent>
        <v-card>
          <v-card-title class="flex-center">
            {{
              isEdit
                ? $tc("workflow.edit") + " " + $tc("workflow.atribut")
                : $tc("workflow.add") + " " + $tc("workflow.atribut")
            }}
          </v-card-title>
          <v-container>
            <v-col cols="12" class="pa-0 px-2">
              <v-form ref="form" v-model="valid">
                <Date />

                <v-alert
                  dense
                  v-if="error"
                  color="red"
                  elevation="5"
                  outlined
                  text
                  type="error"
                  align="center"
                >
                  {{ alertValidate }}</v-alert
                >

                <v-select
                  v-model="data.operid"
                  outlined
                  label="Operador"
                  :rules="rules"
                  item-value="operId"
                  item-text="nombre"
                  :items="isEdit ? getOperatorsEdit : getOperators"
                  :disabled="isEdit"
                  dense
                  class="pt-5"
                />

                <v-select
                  v-model="data.level"
                  outlined
                  label="Nivel"
                  :rules="rules"
                  item-value="id"
                  item-text="name"
                  :items="getLevels"
                  dense
                />
              </v-form>
            </v-col>
          </v-container>
          <v-row class="justify-space-between mx-4 pb-6">
            <v-btn class="bt-exit" @click="cancel"
              >{{ $tc("editRegistrations.cancel") }}
            </v-btn>
            <v-btn class="bt-acept" @click="validate">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showDelete" max-width="300px" persistent>
        <v-card>
          <v-card-title class="flex-center">
            {{ $tc("workflow.delete") + " " + $tc("workflow.atribut") }}
          </v-card-title>
          <v-card-actions class="flex-center">
            <div class="flex-center">
              <v-btn class="bt-exit mr-2 mb-2" @click="cancel"
                >{{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn class="bt-acept" @click="deleteAtt">
                {{ $tc("editRegistrations.acept") }}</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isLoading"
        class="dialog__loader"
        :overlay-opacity="0.3"
      >
        <Loader :loading="isLoading" />
      </v-dialog>
    </v-col>
    <Alerts :alert="errorAlert" :color="colorError" :textAlert="textAlertOk" />
    <Alerts :alert="ok" :color="colorOk" :textAlert="textAlertOk" />
  </v-container>
</template>

<script>
import moment from "moment";
import Navigation from "../commons/Navigation.vue";
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import attributes from "../../../store/workflow/attributes";
import Loader from "../../Complement/Loader.vue";
import Date from "../../GestionEmpleados/commons/Date.vue";
import commons from "../../../store/workflow/commons";
import levels from "../../../store/workflow/levels";
import operators from "../../../store/workflow/operators";
import Alerts from "../../GestionEmpleados/commons/Alerts.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: { TableWithSearch, Navigation, Loader, Date, Alerts },
  data() {
    return {
      type: "Atributos",
      search: "",
      data: {
        operid: null,
        from: null,
        to: null,
        level: null,
      },
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      title: "Atributos",
      titleTable: "WF_Atributos",
      error: false,
      alertValidate: "",
      valid: true,
      isLoading: false,
      colorError: "#FF8D58",
      colorOk: "#82A1D0",
      textAlertOk: "",
      errorAlert: false,
      ok: false,
      showDelete: false,
      deleteItems: null,
      editItems: [],
      checkTo: this.$store.state.employees.checkTo,
      headers: [
        {
          text: "Operador",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Nivel",
          value: "levelText",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "150px",
        },
      ],
    };
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.isLoading = true;
    attributes.dispatch("getAttributes");
    operators.dispatch("getOperators").then(() => {
      this.isLoading = false;
      this.$store.commit("employees/setCheckTo", true);
    });
  },
  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    getAttributes() {
      return attributes.state.attributes.map((item) => ({
        ...item,
        levelText: `${item.level} - ${item.levelName}`,
      }));
    },
    getOperators() {
      return this.unassignedOperators();
    },
    getOperatorsEdit() {
      return this.operatorsEdit();
    },
    isChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    isFirefox() {
      return /Firefox/.test(navigator.userAgent);
    },

    showAdd: {
      get() {
        return commons.state.showAdd;
      },
      set(newValue) {
        return newValue;
      },
    },
    isEdit: {
      get() {
        return commons.state.isEdit;
      },
      set(newValue) {
        return newValue;
      },
    },
    getLevels() {
      return levels.state.levels;
    },
  },
  methods: {
    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    openDialog(type, item) {
      switch (type) {
        case "add":
          this.addExecution();
          break;
        case "edit":
          this.editExecution(item);
          break;
        case "delete":
          this.deleteExecution(item);
          break;

        default:
          break;
      }
    },
    deleteExecution(item) {
      this.showDelete = true;
      this.deleteItems = item.operId;
    },
    addExecution() {
      commons.commit("setShowAdd", true);
      commons.commit("setIsEdit", false);
      attributes.dispatch("getAttributes");
      levels.dispatch("getLevels");
    },
    editExecution(item) {
      levels.dispatch("getLevels");
      commons.commit("setShowAdd", true);
      this.showAdd = true;
      commons.commit("setIsEdit", true);
      this.isEdit = true;
      this.data = {
        operid: item.operId,
        level: item.levelId,
        from: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
        to:
          item.to !== " "
            ? item.to.slice(0, 10).split(/\D/).reverse().join("-")
            : null,
        haNoEx: item.to == " " ? true : false,
      };
      this.checkTo = item.to == " " ? true : false;
      this.$store.commit("employees/setCheckTo", this.checkTo);
      this.$store.commit("employees/setDateTo", this.data.to);
      this.$store.commit("employees/setDateFrom", this.data.from);
    },
    cancel() {
      if (this.showAdd) {
        commons.commit("setShowAdd", false);
        this.showAdd = false;
        this.$refs.form.resetValidation();
        this.data = {
          operid: null,
          from: null,
          to: null,
          level: null,
        };
        this.ok = false;
        this.errorAlert = false;
        this.checkTo = true;
        const day = moment().format("YYYY-MM-DD");
        this.$store.commit("employees/setDateTo", null);
        this.$store.commit("employees/setDateFrom", day);
        this.$store.commit("employees/setCheckTo", this.checkTo);
      } else {
        this.showDelete = false;
      }
    },
    //valida el formulario de edicion y add
    validate() {
      let valid = this.$refs.form.validate();
      if (this.$store.state.employees.checkTo) {
        this.data.to = null;
        this.data.haNoEx = true;
      } else {
        this.data.haNoEx = false;
      }
      if (valid) {
        if (this.isEdit) {
          this.edit();
        } else {
          this.add();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    edit() {
      this.isLoading = true;
      let payload = {
        operid: this.data.operid,
        level: this.data.level,
        from: this.$store.state.employees.dateFrom,
        to: this.$store.state.employees.dateTo,
        haNoEx: this.data.haNoEx,
        nombre: this.searchOper(this.data.operid),
        nivel: this.searchLevel(this.data.level).nivel,
        nombreNivel: this.searchLevel(this.data.level).nombreNivel,
      };
      attributes.commit("setEdit", payload);
      attributes
        .dispatch("edit")
        .then(() => {
          this.ok = true;
          this.textAlertOk = "Se edito el atributo";
        })
        .catch((e) => {
          console.log(e);
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      this.isLoading = false;
      this.cancel();
    },
    add() {
      this.isLoading = true;
      let payload = {
        operId: this.data.operid,
        nivelId: this.data.level,
        fecDesde: this.$store.state.employees.dateFrom + "T00:00:00.000Z",
        fecHasta:
          this.$store.state.employees.dateTo !== null
            ? this.$store.state.employees.dateTo + "T00:00:00.000Z"
            : null,
        nombre: this.searchOper(this.data.operid),
        nivel: this.searchLevel(this.data.level).nivel,
        nombreNivel: this.searchLevel(this.data.level).nombreNivel,
      };
      attributes.commit("setNew", payload);
      attributes
        .dispatch("new")
        .then(() => {
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = "Se agrego el nuevo atributo";
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      this.showAdd = false;

      this.cancel();
    },
    deleteAtt() {
      attributes.commit("setDeleteItem", this.deleteItems);
      attributes
        .dispatch("delete")
        .then(() => {
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = "Se eliminó el nuevo atributo";
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      this.cancel();
    },
    //operadores no asignados
    unassignedOperators() {
      let unassigned = operators.state.operators.filter((oper) => {
        for (
          let index = 0;
          index < attributes.state.attributes.length;
          index++
        ) {
          if (oper.operId == attributes.state.attributes[index].operId) {
            return false;
          }
        }
        return true;
      });

      return unassigned;
    },
    //funcion para obtener los operadores del formulario de edición
    operatorsEdit() {
      let allOpers = operators.state.operators.filter((oper) => {
        for (
          let index = 0;
          index < attributes.state.attributes.length;
          index++
        ) {
          if (oper.operId == attributes.state.attributes[index].operId) {
            return false;
          }
          if (oper.operId == this.data.operid) {
            return true;
          }
        }
        return true;
      });
      return allOpers;
    },

    //busca el nombre del operador
    searchOper(item) {
      let name = operators.state.operators.filter(
        (element) => {
          return element.operId === item;
        },
        [0],
      );
      return name[0].nombre;
    },

    //busca el nombre del nivel
    searchLevel(item) {
      let name = levels.state.levels.filter(
        (element) => {
          return element.id === item;
        },
        [0],
      );
      return { nombreNivel: name[0].name, nivel: name[0].value };
    },
  },
};
</script>

<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.container {
  max-width: 100%;
}
</style>
